export const PagePath = {
  //shared
  lnswIdpLogin: '/lnsw-idp/login',
  lnswIdpLoginCallback: '/lnsw-idp/oidc/callback',
  lnswIdpLogout: '/lnsw-idp/oidc/logout',
  paymentSuccessCallback: '/payment/success',
  paymentCancelCallback: '/payment/cancel',
  timeout: '/timeout',

  // Item New
  plantItemNewRoot: '/item-new',
  holderDetails: '/item-new/holder-details',
  plantItemList: '/item-new/plant-item-list',
  plantDetails: '/item-new/plant-details',
  associatedDesign: '/item-new/associated-design',
  relatedItemDetails: '/item-new/related-item-details',
  fees: '/item-new/fees',
  payment: '/item-new/payment',
  applicationById: '/item-new/application/:id',
  invalidApplication: '/item-new/invalid-application',
  confirmation: '/item-new/confirmation',
  declaration: '/item-new/declaration',
  // Design
  plantDesignRoot: '/design',
  plantDesignBeforeYouStart: '/design/before-you-start',
  plantDesignWhatYouNeed: '/design/what-you-need',
  plantDesignApplicantDetails: '/design/applicant-details',
  plantDesignRegistrationHolder: '/design/holder-details',
  plantDesignDetails: '/design/design-details',
  plantDesignDrawingAndTechnicalDetails: '/design/drawings-tech-details',
  plantDesignAddDrawing: '/design/add-drawing',
  plantDesignAddTechStandard: '/design/add-tech-standard',
  plantDesignDesignerVerifierDetails: '/design/verifier-details',
  plantDesignDeclaration: '/design/declaration',
  plantDesignConfirmation: '/design/confirmation',
  plantDesignFees: '/design/fees',
  plantDesignReview: '/design/review',
  plantDesignApplicationById: '/design/application/:id',
  // Item Renewal
  plantItemRenewalRoot: '/item-renewal',
  plantItemRenewalFind: '/item-renewal/find',
  plantItemRenewalReviewItems: '/item-renewal/review-items',
  plantItemRenewalAddCertificates: '/item-renewal/add-certificates',
  plantItemRenewalEditItem: '/item-renewal/edit-item',
  plantItemRenewalContactDetails: '/item-renewal/contact-details',
  plantItemRenewalDeclaration: '/item-renewal/declaration',
  plantItemRenewalFees: '/item-renewal/fees',
  plantItemRenewalConfirmation: '/item-renewal/confirmation',
};
